import React, { useState } from 'react';
import { api } from '../config/api';

export const DebugPage: React.FC = () => {
  const [results, setResults] = useState<any>({});
  const [loading, setLoading] = useState(false);

  const runTests = async () => {
    setLoading(true);
    setResults({});

    try {
      // Test 1: Check auth token
      const token = localStorage.getItem('accessToken');
      setResults((prev: any) => ({ ...prev, tokenExists: !!token, token: token ? `${token.substring(0, 20)}...` : null }));

      // Test 2: Current user
      try {
        const meResponse = await api.get('/auth/me');
        setResults((prev: any) => ({ ...prev, currentUser: meResponse.data }));
      } catch (e: any) {
        setResults((prev: any) => ({ ...prev, currentUserError: e.response?.data || e.message }));
      }

      // Test 3: Processing status
      try {
        const procResponse = await api.get('/documents/debug/processing-status');
        setResults((prev: any) => ({ ...prev, processingStatus: procResponse.data }));
      } catch (e: any) {
        setResults((prev: any) => ({ ...prev, processingStatusError: e.response?.data || e.message }));
      }

      // Test 4: PDF deps
      try {
        const pdfResponse = await api.get('/documents/debug/test-pdf');
        setResults((prev: any) => ({ ...prev, pdfDeps: pdfResponse.data }));
      } catch (e: any) {
        setResults((prev: any) => ({ ...prev, pdfDepsError: e.response?.data || e.message }));
      }

      // Test 5: Try a simple document list
      try {
        const docsResponse = await api.get('/documents/');
        setResults((prev: any) => ({ ...prev, documentCount: docsResponse.data.length }));
      } catch (e: any) {
        setResults((prev: any) => ({ ...prev, documentsError: e.response?.data || e.message }));
      }

    } catch (error: any) {
      setResults((prev: any) => ({ ...prev, generalError: error.message }));
    }

    setLoading(false);
  };

  const resetFailedDocs = async () => {
    try {
      const response = await api.post('/documents/debug/reset-failed');
      alert(`Success: ${response.data.message}`);
      runTests(); // Refresh the data
    } catch (error: any) {
      alert(`Error: ${error.response?.data?.detail || error.message}`);
    }
  };

  const processOneDoc = async () => {
    try {
      const response = await api.post('/documents/debug/process-one');
      setResults((prev: any) => ({ ...prev, processOneResult: response.data }));
    } catch (error: any) {
      alert(`Error: ${error.response?.data?.detail || error.message}`);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Debug Page</h1>
      
      <div className="mb-4 space-x-4">
        <button
          onClick={runTests}
          disabled={loading}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:opacity-50"
        >
          {loading ? 'Running Tests...' : 'Run Debug Tests'}
        </button>
        
        <button
          onClick={resetFailedDocs}
          className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600"
        >
          Reset Failed Documents
        </button>
        
        <button
          onClick={processOneDoc}
          className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
        >
          Process One Document
        </button>
      </div>

      <div className="bg-gray-100 p-4 rounded">
        <pre className="text-sm overflow-auto">
          {JSON.stringify(results, null, 2)}
        </pre>
      </div>

      <div className="mt-6">
        <h2 className="text-xl font-semibold mb-2">Quick Actions</h2>
        <div className="space-y-2">
          <button
            onClick={() => window.location.href = '/login'}
            className="block text-blue-500 hover:underline"
          >
            Go to Login (if auth is broken)
          </button>
          <button
            onClick={() => {
              localStorage.removeItem('accessToken');
              window.location.href = '/login';
            }}
            className="block text-red-500 hover:underline"
          >
            Clear Token and Re-login
          </button>
        </div>
      </div>
    </div>
  );
};